export { default as AppThirdParties } from "./AppThirdParties"
